import React, { Component } from "react";
import LayoutContainer from "./Layout/LayoutContainer";
import { DashboardComponent } from "./DashboardComponent";
import PanelContainer from "./Panel/PanelContainer";
import { Header } from "./Header/HeaderComponent";
import { InfoTabsComponent } from "./InfoTabs/InfoTabsComponent";
import { Sidebar } from "./Sidebar/SidebarComponent";
import TogglePanelsComponent from "./TogglePanels/TogglePanelsComponent";
import { Row, Col } from "antd";
import { getAuthHeader } from "../../utils/security";
import { urlPath } from "../Settings";
import "./Dashboard.css";

const mappingUrl = urlPath + "/api/custommappings";

class DashboardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedList: ["ArtworkType", "ProofLink", "XandrNative", "XandrWallpaper"],
      custommappings: null
    };
  }
  loadCustomMappings = (type) => {
    fetch(mappingUrl + (type? "?type=" + type: ""), {
      credentials: "include",
      headers: getAuthHeader()
    })
      .then(response => response.json())
      .then(response => {
        this.setState({ custommappings: response });
      })
      .catch(e => {
        console.error("Cannot load mapping", e);
      });
  };
  componentDidMount() {
    this.loadCustomMappings();
  }
  togglePanels = checkedList => {
    console.log(checkedList);
    this.setState({ checkedList });
  };
  render() {
    const { custommappings, checkedList } = this.state;
    if (custommappings)
      return (
        <DashboardComponent>
          <Header />
          <Sidebar />
          <Row gutter={16}>
            <Col xs={24} md={12} lg={8}>
              {checkedList.map(
                (item, index) =>
                item === "ArtworkType" && (
                    <PanelContainer
                      key={index}
                      type="ArtworkType"
                      custommappings={custommappings}
                      loadCustomMappings={this.loadCustomMappings}
                    />
                  )
              )}
            </Col>
            <Col xs={24} md={12} lg={15}>
              {false && (
                <TogglePanelsComponent togglePanels={this.togglePanels} />
              )}
              {checkedList.map(
                (item, index) =>
                  item === "ProofLink" && (
                    <PanelContainer
                      key={index}
                      type="ProofLink"
                      custommappings={custommappings}
                      loadCustomMappings={this.loadCustomMappings}
                    />
                  )
              )}
            </Col>
            <Col xs={24} md={12} lg={15}>
              {false && (
                <TogglePanelsComponent togglePanels={this.togglePanels} />
              )}
              {checkedList.map(
                (item, index) =>
                  item === "XandrNative" && (
                    <PanelContainer
                      key={index}
                      type="XandrNative"
                      custommappings={custommappings}
                      loadCustomMappings={this.loadCustomMappings}
                    />
                  )
              )}
            </Col>
            <Col xs={24} md={12} lg={15}>
              {checkedList.map(
                (item, index) =>
                item === "XandrWallpaper" && (
                    <PanelContainer
                      key={index}
                      type="XandrWallpaper"
                      custommappings={custommappings}
                      loadCustomMappings={this.loadCustomMappings}
                    />
                  )
              )}
            </Col>
          </Row>
        </DashboardComponent>
      );
    return null;
  }
}

export default DashboardContainer;



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardContainer.js